const ProductBoxTag = props => {
  const { tags } = props;
  const getTagsArray = raw =>
    Array.isArray(raw)
      ? raw
      : (raw ?? '')
        .split(',')
        .map(t => t.trim())
        .filter(Boolean);
  const firstTag = getTagsArray(tags)[0];   // undefined if there are no tags
  /* -------------------------------------------------------------------------- */
  return (
    <>
      {firstTag && (
        <div className="relative bg-cover text-white uppercase z-10">
          <span className="absolute -top-[6.1px] right-[10px] after:absolute after:content-[''] after:w-0 after:h-0 after:left-0 after:-bottom-[9px] sm:after:-bottom-[9px] after:border-l-[60px] after:border-l-transparent after:border-r-[60px] after:border-r-transparent after:border-t-[10px] after:border-t-[#f60362]">
            <span className="relative block w-[120px] text-center bg-[#f60362] text-xs md:text-sm leading-none pt-2 md:pt-3 pb-1 px-1 md:px-2 rounded-tr-lg before:absolute before:content-[''] before:w-1.5 before:h-1.5 before:-left-1.5 before:top-0 before:bg-[#f60362] after:absolute after:content-[''] after:w-2 after:h-1.5 after:-left-2 after:top-0 after:bg-[#C02031] after:rounded-tl-lg after:rounded-tr-lg">
              {firstTag}
            </span>
          </span>
        </div>
      )}
    </>
  );
};

export default ProductBoxTag;
